import type { InputHTMLAttributes } from 'react';
import styles from './Field.module.css';

interface IFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  /** Optional helper text rendered under the input. */
  hint?: string;
  requiredMark?: boolean;
}

/**
 * Labeled text input. The `<label>` wraps the `<input>` for implicit
 * association, so consumers get an accessible field without wiring `htmlFor`.
 * Shared across the auth forms (login, connect-provider).
 */
export function Field({ label, hint, requiredMark, className, ...inputProps }: IFieldProps) {
  return (
    <label className={styles.field}>
      <span>
        {label}
        {requiredMark && (
          <span className={styles.required} aria-hidden="true">*</span>
        )}
      </span>
      <input className={className ? `${styles.input} ${className}` : styles.input} {...inputProps} />
      {hint ? <small className={styles.hint}>{hint}</small> : null}
    </label>
  );
}
